module.exports = __webpack_public_path__ + "img/931584293685988_image.jpg";